var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _line, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHair5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 243.9 268",
    style: {
      enableBackground: "new 0 0 243.9 268"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:url(#SVGID_1_);}\n\t.st2{display:inline;fill:#A93651;}\n\t.st3{display:inline;fill:url(#SVGID_00000062889717384233421890000016543616103664315526_);}\n\t.st4{display:inline;fill:url(#SVGID_00000025444025771499261770000001274899938622480804_);}\n\t.st5{display:inline;fill:url(#SVGID_00000135671416187709301190000018179612120635431566_);}\n\t.st6{display:inline;fill:url(#SVGID_00000130606915506176528750000011495887716533637513_);}\n\t.st7{display:inline;fill:#681642;}\n\t.st8{display:inline;fill:#AE4151;}\n\t.st9{display:inline;opacity:0.6;fill:#D177B8;enable-background:new    ;}\n\t.st10{display:inline;fill:url(#SVGID_00000172437685064182481530000007758697768385995148_);}\n\t.st11{display:inline;fill:url(#SVGID_00000018199656827565552660000001340746261610112384_);}\n\t.st12{display:inline;fill:url(#SVGID_00000086672470109977074470000014268104549517687947_);}\n\t.st13{display:inline;fill:url(#SVGID_00000119825242868245892400000017712547219614955656_);}\n\t.st14{display:inline;fill:url(#SVGID_00000025410603390561239630000002688173586447542697_);}\n\t.st15{display:inline;fill:#D177B8;}\n\t.st16{display:inline;fill:url(#SVGID_00000116951385430534110220000004664816839193686176_);}\n\t.st17{display:inline;fill:url(#SVGID_00000172424698219511364300000003388578774115116693_);}\n\t.st18{display:inline;fill:url(#SVGID_00000065795459251996005800000009839408599570504080_);}\n\t.st19{display:inline;fill:url(#SVGID_00000009583084065148979300000003459364276028556685_);}\n\t.st20{display:inline;fill:url(#SVGID_00000176732164434207856960000008995545958225596091_);}\n\t.st21{display:inline;fill:url(#SVGID_00000074419112488006907830000010770477348686333335_);}\n\t.st22{display:inline;fill:url(#SVGID_00000009557762628956945790000012802547903659653540_);}\n\t.st23{display:inline;fill:#FFD9BB;}\n\t.st24{fill:url(#SVGID_00000166654142901607730770000014939232991018140345_);}\n\t.st25{fill:url(#SVGID_00000073688488546723340650000017440751240607410853_);}\n\t.st26{fill:#A773D8;}\n\t.st27{fill:url(#SVGID_00000073001340626913943320000015657601150281590196_);}\n\t.st28{opacity:0.6;fill:#8E1371;enable-background:new    ;}\n\t.st29{fill:#7A81F4;}\n\t.st30{fill:url(#SVGID_00000091701109443271586370000005640344700732808852_);}\n\t.st31{fill:url(#SVGID_00000070797415075751665780000017994691645378805948_);}\n\t.st32{fill:url(#SVGID_00000128458899934578997070000015969899261748659643_);}\n\t.st33{fill:url(#SVGID_00000180361064799814417740000012582612908901783951_);}\n\t.st34{fill:none;}\n\t.st35{fill:url(#SVGID_00000060745683251445196870000006167957382491382707_);}\n\t.st36{display:inline;}\n\t.st37{fill:url(#SVGID_00000027600684775699830230000005355427247125094540_);}\n\t.st38{fill:url(#SVGID_00000004525482272404434940000003770586862961741456_);}\n\t.st39{opacity:0.6;fill:#D177B8;enable-background:new    ;}\n\t.st40{fill:url(#SVGID_00000159433594786778074860000000664529644389847727_);}\n\t.st41{fill:url(#SVGID_00000059286258252879525740000000275299036584817284_);}\n\t.st42{fill:url(#SVGID_00000173883510174477022750000010467494342739184295_);}\n\t.st43{display:inline;fill:url(#SVGID_00000080203420346566120820000008037460887244393650_);}\n\t.st44{fill:url(#SVGID_00000115516369027558117180000011353864724011312805_);}\n\t.st45{fill:url(#SVGID_00000000937871277822826760000002877017042941533825_);}\n\t.st46{opacity:0.6;fill:url(#SVGID_00000081640457842593575620000014093150536629201841_);enable-background:new    ;}\n\t.st47{opacity:0.6;fill:url(#SVGID_00000005244308450202827480000005621894057734547605_);enable-background:new    ;}\n\t.st48{fill:url(#SVGID_00000015320363464976256180000016988739586814356628_);}\n\t.st49{opacity:0.6;fill:url(#SVGID_00000125578329141467999430000013988256890389911221_);enable-background:new    ;}\n\t.st50{opacity:0.6;fill:url(#SVGID_00000159445097472442418840000017812754319904621219_);enable-background:new    ;}\n\t.st51{fill:#DD6B7C;}\n\t.st52{fill:url(#SVGID_00000162342704765513668120000002529843470362598571_);}\n\t.st53{opacity:0.6;fill:url(#SVGID_00000141456146590498924390000013621598113570950797_);enable-background:new    ;}\n\t.st54{opacity:0.6;fill:url(#SVGID_00000083780314458071801150000012032252821564700090_);enable-background:new    ;}\n\t.st55{fill:url(#SVGID_00000046314309631778070560000004134367135571300996_);}\n\t.st56{display:inline;fill:url(#SVGID_00000162331603555387828420000015603448558625591949_);}\n\t.st57{display:inline;fill:url(#SVGID_00000048502619211798307830000011275476850903302584_);}\n\t.st58{fill:url(#SVGID_00000165236036574773098610000011344212491545650065_);}\n\t.st59{fill:url(#SVGID_00000085964898078492185290000015197433998947102655_);}\n\t.st60{fill:url(#SVGID_00000031195779865589608450000005628294770696598144_);}\n\t.st61{opacity:0.6;fill:url(#SVGID_00000078738216570581412350000016526371724721235382_);enable-background:new    ;}\n\t.st62{opacity:0.6;fill:url(#SVGID_00000048487221141905029210000014386774362458930847_);enable-background:new    ;}\n\t.st63{fill:url(#SVGID_00000068657717529751836520000000267189705406673554_);}\n\t.st64{opacity:0.6;fill:url(#SVGID_00000129182724141709460800000002694326961177102004_);enable-background:new    ;}\n\t.st65{opacity:0.6;fill:url(#SVGID_00000104666648769764223540000005985405285117231257_);enable-background:new    ;}\n\t.st66{fill:url(#SVGID_00000157267804593298961710000018351691952117839800_);}\n\t.st67{opacity:0.6;fill:url(#SVGID_00000007422938447660907340000009365668219227443883_);enable-background:new    ;}\n\t.st68{opacity:0.6;fill:url(#SVGID_00000039828638599174987070000006262709921247596431_);enable-background:new    ;}\n\t.st69{fill:url(#SVGID_00000031900356216930063940000002797793517153459349_);}\n\t.st70{fill:url(#SVGID_00000164508991188581766950000013326558079607542664_);}\n\t.st71{fill:url(#SVGID_00000106838647701645668750000005097920633775547039_);}\n\t.st72{fill:url(#SVGID_00000006692902942396413030000009356808901841570736_);}\n\t.st73{fill:url(#SVGID_00000103266579443188990800000007219702338544350119_);}\n\t.st74{fill:url(#SVGID_00000084488135376164180120000009430148093828943801_);}\n\t.st75{fill:url(#SVGID_00000167385733967943869020000015327261059899922818_);}\n\t.st76{fill:#D177B8;}\n\t.st77{fill:url(#SVGID_00000070814853328835120080000012322446608847123092_);}\n\t.st78{fill:#FFD9BB;}\n\t.st79{fill:url(#SVGID_00000101095712315283845350000010989050616885726111_);}\n\t.st80{fill:url(#SVGID_00000030471881632339797590000003557568511795244162_);}\n\t.st81{opacity:0.6;fill:#D177B8;}\n\t.st82{fill:url(#SVGID_00000013179412773602821330000012321513583378418106_);}\n\t.st83{fill:url(#SVGID_00000076600089684831887100000005401837293705235883_);}\n\t.st84{fill:url(#SVGID_00000009584415786688999370000000769583306652021920_);}\n\t.st85{fill:url(#SVGID_00000155858063905315757740000003354480236265481642_);}\n\t.st86{fill:url(#SVGID_00000139994372205970259630000011739128848983979663_);}\n\t.st87{fill:url(#SVGID_00000054960516768771794700000016016283186360629439_);}\n\t.st88{fill:url(#SVGID_00000003083406892029632750000011372759143624429984_);}\n\t.st89{fill:url(#SVGID_00000096033614938830425700000015343248575460832384_);}\n\t.st90{opacity:0.6;fill:url(#SVGID_00000034787126804240303650000008864682032228359352_);}\n\t.st91{opacity:0.6;fill:url(#SVGID_00000182494346311128561760000015123668608571034791_);}\n\t.st92{fill:url(#SVGID_00000155147675640573224420000018093959955142858398_);}\n\t.st93{opacity:0.6;fill:url(#SVGID_00000035525809679117485660000003326539737649909665_);}\n\t.st94{opacity:0.6;fill:url(#SVGID_00000111874420799250417820000007082096831890780589_);}\n\t.st95{fill:url(#SVGID_00000172422570815927013980000006451072847569440163_);}\n\t.st96{opacity:0.6;fill:url(#SVGID_00000026870298633100699020000008447168275061656198_);}\n\t.st97{opacity:0.6;fill:url(#SVGID_00000079447374880280758290000000124873904869689766_);}\n\t.st98{fill:url(#SVGID_00000007427898368995327630000003500455054891816341_);}\n\t.st99{fill:url(#SVGID_00000124861862597962893260000006197357623699776135_);}\n\t.st100{fill:url(#SVGID_00000015350505749705499170000013617715321890894723_);}\n\t.st101{fill:url(#SVGID_00000143590893048758229950000015104096486704787339_);}\n\t.st102{fill:url(#SVGID_00000100356036492079563740000003624606202557264522_);}\n\t.st103{fill:url(#SVGID_00000076586588878721239270000017829473184038361732_);}\n\t.st104{fill:url(#SVGID_00000101804360502638027460000001475264107646133680_);}\n\t.st105{fill:url(#SVGID_00000179606245601183813280000015679947766859690168_);}\n\t.st106{fill:url(#SVGID_00000055674327727932777380000006041127951006388141_);}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.3012,
    y1: 629.3477,
    x2: 44.3012,
    y2: 576.1768,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8E2542"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.6,23c0,0-4.4-20.4-25.2-20.9C25.5,1.7,26.6,29.2,26.6,29.2l3.7-2.2c0,0-1.4-18.6,10.2-20.8 c11.6-2.3,21.1,4,21.1,4s-29.3-10.1-40,4.7s-2,43.4,18.6,40.2C60.8,51.8,71.6,23,71.6,23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17,31.4c0,0,24.6-23.1,49.6-6.8l2.1-0.7c0,0-23.5-18.1-51.3,1.1L17,31.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.6,16.4c0,0,28.2-14.1,49.2,1.6l-2-3.7c0,0-9.8-11.2-46.2,0.6L20.6,16.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.7,51.9c0,0-0.5-30.1,36.6-26L62,26.5c0,0-34.8-2-32.5,27.1L26.7,51.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092417505410713792670000005653832557959950255_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.5069,
    y1: 623.457,
    x2: 200.5069,
    y2: 574,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8E2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000092417505410713792670000005653832557959950255_)"
    },
    d: "M173,24.6 c0,0,2.9-26.1,26.5-24.5c23.5,1.6,17.6,33.2,17.6,33.2s1.4-25.4-12.6-30.2s-21.6,3.8-21.6,3.8S197.8-2,217,8.3s12.9,42.8-15.8,41.2 L173,24.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069380443620613534940000006192792795596871817_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.6423,
    y1: 694.4,
    x2: 121.6423,
    y2: 590.3993,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92314B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000069380443620613534940000006192792795596871817_)"
    },
    d: "M193.1,120.4 c0,0-4-24.4-4.6-38.4c-0.5-14-10.4-26.5-18.7-33.7c-1.7-1.5-3.7-2.9-5.6-4.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.1,0-0.1-0.1-0.1-0.1c-7-4.2-14.1-6.3-14.1-6.3S99,35.4,82,41.6c-2.7,1-5.2,2.3-7.3,3.8l0,0c-11.1,7.9-14.6,21.7-16.9,28.5 c-2.7,8.1,1.2,17.4-9.7,42.8c0,0-5.8-14.9-8.1-30.4c-2.2-14.7-2-39.7,8.1-50.9l0,0c0.5-0.6,1-1.1,1.6-1.6 c16.2-14.3,54.4-17.4,72.5-17.4s39.5-0.3,62.8,11.7c4.3,2.2,7.9,5.7,10.7,10C208.7,57.6,206.6,95.1,193.1,120.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025442442249625461220000013033807913626528170_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.1496,
    y1: 781,
    x2: 41.1496,
    y2: 686.9,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92314B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000025442442249625461220000013033807913626528170_)"
    },
    d: "M48.3,116.7 c0,0-5.5,30.1-13.9,53.3s15.3,37,15.3,37S32,190.8,36.3,170.6s13.5-43.1,13.4-57.7L48.3,116.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181051389390069556060000003185408385893281163_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.7581,
    y1: 776.8,
    x2: 199.7581,
    y2: 692.9,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92314B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000181051389390069556060000003185408385893281163_)"
    },
    d: "M193.1,120.4 c0,0,2.7,8.5,8.3,37.3c5.7,28.8-5.7,45.1-5.7,45.1s11.2-12.2,10.7-31.5s-9.5-38.3-12.5-52.4L193.1,120.4z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M114.7,37.4c0,0-6-10.1-10.5-11.5S72.4,45.5,82.9,86.3c0,0-1.4-37.5,20.4-52.7c0,0,2.9,1.1,6.3,4 C109.6,37.6,114.2,37.8,114.7,37.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.4,43.6c0,0,19-0.1,28.6-10.4l4.1,5.2c0,0-3.9,10.3-26.2,9.8L163.4,43.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158,40.7c0,0,10.6-10.3,22.6-14.9l-2.8-1.2c0,0-10.7,3.8-20.9,15.6L158,40.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.4,43.3c0,0-9-6-17.6-16.3L59,27.8c0,0,3.6,10.7,18.4,16L78.4,43.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.6,63.5c0,0-12.2-2.2-18.9-18.1l-2.2,8.2c0,0,7.3,15.2,18.2,18.2L61.6,63.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.2,37.1c0,0,21.1-16.3,38.5-15.7l2,0.6c0,0-17.7-0.8-37.7,15.1H130.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.3,25.9c0,0,26.2,1.5,42.5,11.9l1.5-0.1c0,0-11.9-11.7-41.7-12.7L63.3,25.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M82.9,86.3c0,0,0.4-38.1,25.5-57.3l-8.5-8C99.9,20.9,70.7,37.2,82.9,86.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M74.8,45.4c-11.1,7.9-14.6,21.7-16.9,28.5c-2.7,8.1,1.2,17.4-9.7,42.8c0,0-5.8-14.9-8.1-30.4 c-2.2-14.7-2-39.7,8.1-50.9l0,0c0,0,7.3,14.4,11.5,15.5C63.7,52.1,74.2,45.8,74.8,45.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M193.1,120.4c0,0-4-24.4-4.6-38.4c-0.5-14-10.4-26.5-18.7-33.7c-1.7-1.5-3.7-2.9-5.6-4.1 c2.4,1.4,9.7,5.2,19.5,6c12,1,11.3-13.1,11.3-13.1l0.8,1C208.7,57.6,206.6,95.1,193.1,120.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M194.4,3.4c0,0,30.1,18,19.3,44.2l2.4-1.1c0,0,9.4-30.4-19.9-43.1C196.2,3.4,194.4,3.4,194.4,3.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190.7,4c0,0,17.3,12,15.3,45.3l2.6-0.3c0,0,0.3-35-16.7-45H190.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.9,9.4c0,0,7.1,19.6-1,36c0,0,4.4-2.1,7.5-8.4c0,0,2.6-11.2,0.6-19.1C226.1,18,222.5,11.5,218.9,9.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158014204391982876570000018227790758178697386_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.2,
    y1: 623.4,
    x2: 187.2,
    y2: 596.8771,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC5E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000158014204391982876570000018227790758178697386_)"
    },
    d: "M173.3,22.9 c0,0,24.6-1.8,27.8,26.5C201.1,49.4,197.2,28.4,173.3,22.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159439345922030475630000016559065933963227063_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.7893,
    y1: 629.0479,
    x2: 55.7893,
    y2: 597.01,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC5E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000159439345922030475630000016559065933963227063_)"
    },
    d: "M71.6,23 c0,0-23.6,5.3-31.4,32C40.2,55,35.3,29.1,71.6,23z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135682273457800651970000011657926311037497479_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.2814,
    y1: 679.9,
    x2: 183.2814,
    y2: 606.7,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FC9090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF386B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000135682273457800651970000011657926311037497479_)"
    },
    d: "M167.4,32.7l-1.7,4.4 c0,0,16.2,11.1,19.7,25.1s11.3,43.7,11.3,43.7s6.7-34.5,3.1-49.9C196.3,40.6,167.4,32.7,167.4,32.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153699947496385425570000016620612969333888392_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.6884,
    y1: 687.9,
    x2: 104.6884,
    y2: 575.6549,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FC9090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF386B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000153699947496385425570000016620612969333888392_)"
    },
    d: "M167.4,32.7l-4.8,3.5 c0,0-5.4,0.5-11.9,0.5s-43.4-0.4-43.4-0.4C95.8,51.1,98.6,85,98.6,85c-14.3-9.9-11.3-29-11.3-29s-19.4,22.5-21,29.8 c-1.5,7.1,9.4,15,10,15.5c-7.4-1.6-11.3-8-12.7-10.7l0,0c-0.4-0.7-0.6-1.2-0.6-1.2c0.1,1.7,0.4,3.2,0.8,4.6l0,0 c2,7.3,6.9,9.2,6.9,9.2c-3.8,0.6-7.6,0-10.8-1l0,0c0,0-0.1,0-0.2-0.1c-4.5-1.3-8-3.4-9.7-4.5c-0.4-0.2-0.7-0.4-1-0.6l0.1,16.9 c0,0-7.8-20.5-8-38.5l0,0c-0.1-4.5,0.3-8.9,1.4-12.7C48.2,43.9,63.1,36,83.4,24.6c2.4-1.3,4.6-2.7,6.7-4l0,0l2.1-1.4 c5.5-3.7,10-7.2,14.4-10.2l3-1.9l0.2-0.1l0,0c5.8-3.4,11.8-5.5,19.9-5.1c1.6,0.1,3.2,0.3,4.7,0.7l0,0c0.1,0,0.3,0.1,0.4,0.1 c0.9,0.2,1.7,0.5,2.6,0.9c14.8,5.6,25,23.2,25,23.2c-5-21.3-8.3-24.1-9.1-25C173.6,17,167.4,32.7,167.4,32.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005948675946764184280000011123596326585703318_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.6003,
    y1: 610.192,
    x2: 180.6003,
    y2: 603.9166,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FC9090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF386B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000005948675946764184280000011123596326585703318_)"
    },
    d: "M167.4,32.7 c0,0,18.3-1.7,26.4,3.5C193.9,36.2,179.8,24.8,167.4,32.7z"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M162.6,36.2c0,0-10.1-24.6-27.7-24.8c-17.6-0.2-27.6,24.9-27.6,24.9S158.6,37.6,162.6,36.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178163349570518521640000000712367052228414891_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.0614,
    y1: 673.95,
    x2: 59.7493,
    y2: 673.95,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000178163349570518521640000000712367052228414891_)"
    },
    d: "M50.1,97.7 c2.9,1.7,8.5,4,9.7,4.5C55.3,100.8,51.7,98.7,50.1,97.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104664508465634097550000014833136637989495431_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.2,
    y1: 640.55,
    x2: 92.1,
    y2: 640.55,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000104664508465634097550000014833136637989495431_)"
    },
    d: "M49.1,97l0.1,16.9 c0,0-7.8-20.5-8-38.5l0,0c5.6-13,26.7-26.4,33.5-34.6c6.7-7.9,14.9-19.6,15.3-20.2l0,0l2.1-1.4c0,0-2.1,5.4-14.8,20.4 S51,58.2,47.1,70.9C43.2,83.5,46.6,95.2,49.1,97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108278035765919572250000009056294290216983717_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.7591,
    y1: 677.4394,
    x2: 78.7591,
    y2: 581.1,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000108278035765919572250000009056294290216983717_)"
    },
    d: "M70.8,103.2 c-3.8,0.6-7.6,0-10.8-1l0,0c-0.6-0.6-14.3-13.3-11.9-24.1C50.4,67,85.3,52.5,92.1,40c6.8-12.6,14.4-30.9,14.4-30.9l3-1.9l0.2-0.1 c-5.3,4.3-7.4,17.7-16,33.6S67.6,68.2,63.6,77.6c-3.8,9-0.1,15.7,0.3,16.3l0,0C66,101.3,70.8,103.2,70.8,103.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036229742921786561370000007418889363279741619_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.6595,
    y1: 625.95,
    x2: 137.5845,
    y2: 625.95,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000036229742921786561370000007418889363279741619_)"
    },
    d: "M134.8,2.7 c1,0.2,2,0.6,2.8,0.9h-0.1c-8-1.8-21.8,15-30.1,27.5C98.4,44.3,87.2,56,87.2,56S67.9,78.5,66.3,85.8c-1.5,7.1,9.4,15,10,15.5 c-7.4-1.6-11.3-8-12.7-10.7l0,0c-0.1-2,0.1-4.7,0.6-7.9c1.2-6.7,36.6-45.8,46.5-61c9.7-15,23.2-19,23.6-19.1l0,0 C134.5,2.6,134.7,2.6,134.8,2.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155107163361606878200000003739374314624071835_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.7502,
    y1: 577.8,
    x2: 138.6345,
    y2: 577.8,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000155107163361606878200000003739374314624071835_)"
    },
    d: "M138.6,4 c-0.3-0.2-0.6-0.3-0.9-0.4C138.1,3.8,138.5,4,138.6,4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073707860607102425280000000358980747760891799_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.1346,
    y1: 630.3,
    x2: 200.9346,
    y2: 630.3,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000073707860607102425280000000358980747760891799_)"
    },
    d: "M171.1,41.4 c0,0,12.6,10.9,19.9,18.2c7.3,7.3,9.9,7.1,9.9,7.1v4.5c0,0-7.1-3.8-13.1-12s-10.9-11.9-10.9-11.9L171.1,41.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111189711394178782360000007665321079600103348_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.8186,
    y1: 647.9,
    x2: 200.0666,
    y2: 647.9,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000111189711394178782360000007665321079600103348_)"
    },
    d: "M184.8,60 c0,0,10.5,22.1,15.2,23.2l-0.5,4.6c0,0-8.6-7.9-12.7-20L184.8,60z"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M97.5,39.2c0,0,10.1-10.9,13.7-18.1c0,0-2.5,2.6-4.5,3.1s-4.2-0.6-4.2-0.6s-8.2,15.9-7.2,15.6 C96.2,38.9,97.5,39.2,97.5,39.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M92.1,37.7c0,0-4.9-0.8-12.5,0c0,0,7.9-8.6,10.2-13.6c0,0,6.4-0.3,9.8-2.4C99.6,21.7,95,33.1,92.1,37.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M72.1,31c0,0,2.8,4.1,4.5,4.2c1.7,0.1,9.4-11.1,9.4-11.1S76.2,29.7,72.1,31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093165893822891785160000000475073436959380149_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.7882,
    y1: 766.153,
    x2: 90.7882,
    y2: 647.1259,
    gradientTransform: "matrix(0.9878 -0.156 0.156 0.9878 -15.7554 -599.3391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6A4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B63651"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093165893822891785160000000475073436959380149_)"
    },
    d: "M220.4,109.7c0.1,0.8-8.6,26.1-8.4,27 l-2.7,4.1l-0.4-0.4c-7.3-23.5-23.1-44.5-25.6-73.2c-2-22.1-20.8-35.5-39.9-36.5c2.2-0.2,25,5,35.2,16.2 c10.7,11.7,8.9-11.4,8.9-11.4C209.7,54.6,217.2,92.1,220.4,109.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018945708342318139430000008817958698915156144_",
    gradientUnits: "userSpaceOnUse",
    x1: -503.6953,
    y1: 671.3649,
    x2: -503.6953,
    y2: 552.3222,
    gradientTransform: "matrix(-0.9878 -0.156 -0.156 0.9878 -346.4135 -599.3391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6A4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B63651"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018945708342318139430000008817958698915156144_)"
    },
    d: "M19.4,108.8c-0.1,0.8,8.6,26.1,8.4,27 l2.7,4.1l0.4-0.4C38.2,116,54,94.9,56.6,66.3c2-22.1,20.8-35.5,39.9-36.5c-2.2-0.2-25,5-35.2,16.2c-10.7,11.7-8.9-11.4-8.9-11.4 C30.1,53.6,22.6,91.2,19.4,108.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M2.6,137.1c0.6-4.4,1.2-9,1.7-13.8c0-0.1,0-0.1,0-0.1c0.2-2,0.5-4,0.7-6C6.9,100,8.5,81.4,10.1,65v-0.1 c0-0.1,0-0.2,0-0.4c0.1-0.8,0.1-1.5,0.2-2.3l0.6-6.4c0,0,0-0.2,0.1-0.6c0-0.2,0-0.4,0.1-0.6c0-0.4,0.1-0.7,0.1-1.1c0,0,0,0,0-0.1 c0-0.3,0.1-0.6,0.1-0.9c0-0.3,0.1-0.7,0.1-1.1c1.8-18.4,3.4-32.1,5-34.5c0.7-1,2-1.8,3.8-2.2l0,0C21.3,12.5,25.1,7.2,32,9 c8.1,2.1,30.3,17.8,30.3,17.8l-8.6,8.8L52,37.3c0,0-11.8-3.3-15.4,3.1c-3.6,6.5,2.1,35.2,9.2,71.1s9.6,76.6,9.3,110.6 c-0.2,28.2-14.7,40.3-19.6,43.6c4.1-3.3,6.7-12.3,6.8-12.9c-2.1,3-4.4,5.3-6.8,7.1c-1.2,0.9-2.4,1.7-3.7,2.4l0,0 c-0.7,0.4-1.4,0.8-2.1,1.1c-7.2,3.4-13.5,3.2-13.5,3.2s7.8-0.4,7.5-14.7c-0.2-9.7-12.6-37.9-18.8-69.2v-0.1 c-1.2-6.3-2.2-12.7-2.8-19.1c-0.3-2.9-0.5-5.7-0.5-8.6c0-0.3,0-0.5,0-0.5C1.6,148.6,1.8,142.8,2.6,137.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036216441500716494980000010154165295192595867_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.3,
    y1: 143.1393,
    x2: 55.3238,
    y2: 143.1393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2821C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9800A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CB8285"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036216441500716494980000010154165295192595867_)"
    },
    d: "M42.5,252.9c-0.2,0.6-2.8,9.6-6.8,12.9 c4.9-3.2,19.4-15.4,19.6-43.6c0.3-34-2.2-74.7-9.3-110.6S33.2,47,36.8,40.5c3.5-6.4,15.4-3.1,15.4-3.1l1.7-1.7l-0.2-3.5 c0,0-23.8-12.3-31.8-11.7c-6.2,0.4-9.4,21.7-10.4,31c0,0.4-0.1,0.8-0.1,1.1s-0.1,0.6-0.1,0.9c0,0,0,0,0,0.1 c0,0.4-0.1,0.7-0.1,1.1c0,0.2,0,0.4-0.1,0.6c0,0.4-0.1,0.6-0.1,0.6l-0.6,6.4L10.2,65c0-0.1,0-0.2,0-0.4 c0.6-4.5,5.9-40.9,12.2-41.1c6.8-0.2,11.6,2,11.6,2s-5.3-1.3-14.2,25.9c-8.9,27.3-12.2,54.1-7.2,76.1s18.4,37.6,32.1,72.1 C58.4,234,42.6,252.8,42.5,252.9c0,0,2.2-27.9-17.2-67.8C6,145.3,5,117.2,5,117.2c-0.2,2-0.5,4-0.7,6c0,0,0,0,0,0.1 c0,1.4,0.4,22.6,10.5,46c10.5,24.2,32.8,59.8,20.8,90.7C38.1,258.2,40.4,255.8,42.5,252.9z"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M53.5,32.2c0,0-15.2-9.1-21.5-6.8c-6.3,2.4-18.1,47.7-18.1,47.7s12.4-17.9,22-20.1c0,0-1.2-11.5,4.3-14.6 s11.9-1.1,11.9-1.1L53.5,32.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M66.1,26.4c0,0-14.7-6.4-14,14.1C52.1,40.5,56.6,32,66.1,26.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057862821539597083590000002624116499145744809_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.6098,
    y1: 833.5876,
    x2: 26.6098,
    y2: 821.7876,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9281EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057862821539597083590000002624116499145744809_)"
    },
    d: "M25,250.2c3,6.4,0,9.4,0,9.4 s5.3-2.3,2.3-11.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016042462655149228430000003789982756216284072_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.4,
    y1: 704.8,
    x2: 3.4,
    y2: 704.8,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9281EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016042462655149228430000003789982756216284072_)"
    },
    d: "M3.4,130.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M241.4,137.1c-0.6-4.4-1.2-9-1.7-13.8c0-0.1,0-0.1,0-0.1c-0.2-2-0.5-4-0.7-6c-1.9-17.2-3.6-35.8-5.1-52.3 v-0.1c0-0.1,0-0.2,0-0.4c-0.1-0.8-0.1-1.5-0.2-2.3l-0.6-6.4c0,0,0-0.2-0.1-0.6c0-0.2,0-0.4-0.1-0.6c0-0.4-0.1-0.7-0.1-1.1 c0,0,0,0,0-0.1c0-0.3-0.1-0.6-0.1-0.9c0-0.3-0.1-0.7-0.1-1.1c-1.8-18.4-3.4-32.1-5-34.5c-0.7-1-2-1.8-3.8-2.2l0,0 c-1.1-2.3-5.8-10.4-12.7-8.5c-8.1,2.1-29.4,20.6-29.4,20.6l8.6,8.8l1.7,1.7c0,0,11.8-3.3,15.4,3.1c3.6,6.5-2.1,35.2-9.2,71.1 c-7.1,35.9-9.6,76.6-9.3,110.6c0.2,28.2,14.7,40.3,19.6,43.6c-4.1-3.3-6.7-12.3-6.8-12.9c2.1,3,4.4,5.3,6.8,7.1 c1.2,0.9,2.4,1.7,3.7,2.4l0,0c0.7,0.4,1.4,0.8,2.1,1.1c7.2,3.4,13.5,3.2,13.5,3.2s-7.8-0.4-7.4-14.7 c0.2-9.7,12.6-37.9,18.8-69.2v-0.1c1.2-6.3,2.2-12.7,2.8-19.1c0.3-2.9,0.5-5.7,0.5-8.6c0-0.3,0-0.5,0-0.5 C242.4,148.6,242.1,142.8,241.4,137.1z M212.3,9.2c5,0.3,7.5,3.4,8.4,5c-8.5-1-21.5,1-21.5,1S205.4,8.8,212.3,9.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067930712727898095200000007287496929629171643_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.8474,
    y1: 64.5374,
    x2: 275.4126,
    y2: 195.1026,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2821C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9800A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CB8285"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067930712727898095200000007287496929629171643_)"
    },
    d: "M201.4,252.9c0.2,0.6,2.8,9.6,6.8,12.9 c-4.9-3.2-19.4-15.4-19.6-43.6c-0.3-34,2.2-74.7,9.3-110.6s12.8-64.6,9.2-71.1c-3.5-6.4-15.4-3.1-15.4-3.1l-1.7-1.7l0.2-3.5 c0,0,23.8-12.3,31.8-11.7c6.2,0.4,9.4,21.7,10.4,31c0,0.4,0.1,0.8,0.1,1.1s0.1,0.6,0.1,0.9c0,0,0,0,0,0.1c0,0.4,0.1,0.7,0.1,1.1 c0,0.2,0,0.4,0.1,0.6c0,0.4,0.1,0.6,0.1,0.6l0.6,6.4l0.2,2.7c0-0.1,0-0.2,0-0.4c-0.6-4.5-5.9-40.9-12.2-41.1 c-6.8-0.2-11.6,2-11.6,2s5.3-1.3,14.2,25.9c8.9,27.3,12.2,54.1,7.2,76.1s-18.3,37.5-32,72S201.4,252.8,201.4,252.9 c0,0-2.2-27.9,17.2-67.8c19.4-39.8,20.4-67.9,20.4-67.9c0.2,2,0.5,4,0.7,6c0,0,0,0,0,0.1c0,1.4-0.4,22.6-10.5,46 c-10.5,24.2-32.8,59.8-20.8,90.7C205.9,258.2,203.5,255.8,201.4,252.9z"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M190.4,32.2c0,0,15.2-9.1,21.5-6.8s18.2,47.7,18.2,47.7s-12.4-17.9-22-20.1c0,0,1.2-11.5-4.3-14.6 s-11.9-1.1-11.9-1.1L190.4,32.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M177.8,26.4c0,0,14.7-6.4,14,14.1C191.9,40.5,187.3,32,177.8,26.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054967242195057641750000004288328123276931971_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.0111,
    y1: 612.6,
    x2: 230.0111,
    y2: 602.7894,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9281EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054967242195057641750000004288328123276931971_)"
    },
    d: "M230.1,38.6c-0.4-8.4,0-9.8,0-9.8"
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 240.2,
    y1: 174.8,
    x2: 240.2,
    y2: 174.8
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062882481773219806100000015471892965626464404_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.0254,
    y1: 837.5,
    x2: 227.0254,
    y2: 729.8,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062882481773219806100000015471892965626464404_)"
    },
    d: "M242.2,155.8c0,3.5-0.3,13.7-3.4,26.9 c0,0.1,0,0.1,0,0.1c-1.2,5.2-2.9,10.8-5.1,16.7c-9.2,24.2-23.5,49-19.7,64c-0.7-0.3-1.4-0.7-2.1-1.1c0,0-1.7-29.7,14.9-57.2 c10.2-17,13.7-32.4,14.8-41.6C242.1,159.9,242.2,157.2,242.2,155.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142154202636401696300000014819992574937543578_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.0308,
    y1: 302.7272,
    x2: 174.0308,
    y2: 560.7011,
    gradientTransform: "matrix(-1 0 0 -1 216.0808 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9259D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142154202636401696300000014819992574937543578_)"
    },
    d: "M12.7-164.5c0.6-4.4,1.2-9,1.7-13.8 c0-0.1,0-0.1,0-0.1c0.2-2,0.5-4,0.7-6c1.9-17.2,3.6-35.8,5.1-52.3v-0.1c0-0.1,0-0.2,0-0.4c0.1-0.8,0.1-1.5,0.2-2.3l0.6-6.4 c0,0,0-0.2,0.1-0.6c0-0.2,0-0.4,0.1-0.6c0-0.4,0.1-0.7,0.1-1.1c0,0,0,0,0-0.1c0-0.3,0.1-0.6,0.1-0.9c0-0.3,0.1-0.7,0.1-1.1 c1.8-18.4,3.4-32.1,5-34.5c0.7-1,2-1.8,3.8-2.2l0,0c1.1-2.3,4.9-7.5,11.8-5.7c8.1,2.1,30.3,17.8,30.3,17.8l-8.6,8.8l-1.7,1.7 c0,0-11.8-3.3-15.4,3.1c-3.6,6.5,2.1,35.2,9.2,71.1s9.6,76.6,9.3,110.6C65-51.4,50.5-39.3,45.6-36c4.1-3.3,6.7-12.3,6.8-12.9 c-2.1,3-4.4,5.3-6.8,7.1c-1.2,0.9-2.4,1.7-3.7,2.4l0,0c-0.7,0.4-1.4,0.8-2.1,1.1c-7.2,3.4-13.5,3.2-13.5,3.2s7.8-0.4,7.5-14.7 C33.6-59.5,21.2-87.7,15-119v-0.1c-1.2-6.3-2.2-12.7-2.8-19.1c-0.3-2.9-0.5-5.7-0.5-8.6c0-0.3,0-0.5,0-0.5 C11.7-152.9,11.9-158.8,12.7-164.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034053207859056951720000007348052927022060471_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.2189,
    y1: 303.69,
    x2: 176.2189,
    y2: 549.0113,
    gradientTransform: "matrix(-1 0 0 -1 216.0808 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034053207859056951720000007348052927022060471_)"
    },
    d: "M52.6-48.7c-0.2,0.6-2.8,9.6-6.8,12.9 c4.9-3.2,19.4-15.4,19.6-43.6c0.3-34-2.2-74.7-9.3-110.6s-12.8-64.6-9.2-71.1c3.5-6.4,15.4-3.1,15.4-3.1l1.7-1.7l-0.2-3.5 c0,0-23.8-12.3-31.8-11.7c-6.2,0.4-9.4,21.7-10.4,31c0,0.4-0.1,0.8-0.1,1.1s-0.1,0.6-0.1,0.9c0,0,0,0,0,0.1 c0,0.4-0.1,0.7-0.1,1.1c0,0.2,0,0.4-0.1,0.6c0,0.4-0.1,0.6-0.1,0.6l-0.6,6.4l-0.2,2.7c0-0.1,0-0.2,0-0.4 c0.6-4.5,5.9-40.9,12.2-41.1c6.8-0.2,11.6,2,11.6,2s-5.3-1.3-14.2,25.9c-8.9,27.3-12.2,54.1-7.2,76.1s18.4,37.6,32.1,72.1 S52.7-48.7,52.6-48.7c0,0,2.2-27.9-17.2-67.8C16-156.3,15-184.4,15-184.4c-0.2,2-0.5,4-0.7,6c0,0,0,0,0,0.1 c0,1.4,0.4,22.6,10.5,46c10.5,24.2,32.8,59.8,20.8,90.7C48.2-43.4,50.5-45.7,52.6-48.7z"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M63.6-269.4c0,0-15.2-9.1-21.5-6.8c-6.3,2.4-18.1,47.7-18.1,47.7s12.4-17.9,22-20.1c0,0-1.2-11.5,4.3-14.6 s11.9-1.1,11.9-1.1L63.6-269.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M76.2-275.2c0,0-14.7-6.4-14,14.1C62.2-261.1,66.7-269.5,76.2-275.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127760631420772675700000003447273357093362879_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.2,
    y1: 302.9878,
    x2: 222.2,
    y2: 563.6761,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9259D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127760631420772675700000003447273357093362879_)"
    },
    d: "M251.5-164.5c-0.6-4.4-1.2-9-1.7-13.8 c0-0.1,0-0.1,0-0.1c-0.2-2-0.5-4-0.7-6c-1.9-17.2-3.6-35.8-5.1-52.3v-0.1c0-0.1,0-0.2,0-0.4c-0.1-0.8-0.1-1.5-0.2-2.3l-0.6-6.4 c0,0,0-0.2-0.1-0.6c0-0.2,0-0.4-0.1-0.6c0-0.4-0.1-0.7-0.1-1.1c0,0,0,0,0-0.1c0-0.3-0.1-0.6-0.1-0.9c0-0.3-0.1-0.7-0.1-1.1 c-1.8-18.4-3.4-32.1-5-34.5c-0.7-1-2-1.8-3.8-2.2l0,0c-1.1-2.3-5.8-10.4-12.7-8.5c-8.1,2.1-29.4,20.6-29.4,20.6l8.6,8.8 l1.7,1.7c0,0,11.8-3.3,15.4,3.1c3.6,6.5-2.1,35.2-9.2,71.1c-7.1,35.9-9.6,76.6-9.3,110.6c0.2,28.2,14.7,40.3,19.6,43.6 c-4.1-3.3-6.7-12.3-6.8-12.9c2.1,3,4.4,5.3,6.8,7.1c1.2,0.9,2.4,1.7,3.7,2.4l0,0c0.7,0.4,1.4,0.8,2.1,1.1 c7.2,3.4,13.5,3.2,13.5,3.2s-7.8-0.4-7.4-14.7c0.2-9.7,12.6-37.9,18.8-69.2v-0.1c1.2-6.3,2.2-12.7,2.8-19.1 c0.3-2.9,0.5-5.7,0.5-8.6c0-0.3,0-0.5,0-0.5C252.5-152.9,252.2-158.8,251.5-164.5z M222.4-292.4c5,0.3,7.5,3.4,8.4,5 c-8.5-1-21.5,1-21.5,1S215.5-292.8,222.4-292.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002354235559434397930000018187518837697396887_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.2381,
    y1: 303.69,
    x2: 224.2381,
    y2: 549.0113,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002354235559434397930000018187518837697396887_)"
    },
    d: "M211.5-48.7c0.2,0.6,2.8,9.6,6.8,12.9 c-4.9-3.2-19.4-15.4-19.6-43.6c-0.3-34,2.2-74.7,9.3-110.6s12.8-64.6,9.2-71.1c-3.5-6.4-15.4-3.1-15.4-3.1l-1.7-1.7l0.2-3.5 c0,0,23.8-12.3,31.8-11.7c6.2,0.4,9.4,21.7,10.4,31c0,0.4,0.1,0.8,0.1,1.1s0.1,0.6,0.1,0.9c0,0,0,0,0,0.1 c0,0.4,0.1,0.7,0.1,1.1c0,0.2,0,0.4,0.1,0.6c0,0.4,0.1,0.6,0.1,0.6l0.6,6.4l0.2,2.7c0-0.1,0-0.2,0-0.4 c-0.6-4.5-5.9-40.9-12.2-41.1c-6.8-0.2-11.6,2-11.6,2s5.3-1.3,14.2,25.9c8.9,27.3,12.2,54.1,7.2,76.1S223-136.5,209.3-102 C195.7-67.5,211.5-48.7,211.5-48.7s-2.2-27.9,17.2-67.8c19.4-39.8,20.4-67.9,20.4-67.9c0.2,2,0.5,4,0.7,6c0,0,0,0,0,0.1 c0,1.4-0.4,22.6-10.5,46c-10.5,24.2-32.8,59.8-20.8,90.7C216-43.4,213.6-45.7,211.5-48.7z"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M200.5-269.4c0,0,15.2-9.1,21.5-6.8c6.3,2.4,18.2,47.7,18.2,47.7s-12.4-17.9-22-20.1 c0,0,1.2-11.5-4.3-14.6s-11.9-1.1-11.9-1.1L200.5-269.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M187.9-275.2c0,0,14.7-6.4,14,14.1C202-261.1,197.5-269.5,187.9-275.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109729755828615713700000006145583769300209031_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.1254,
    y1: 305.99,
    x2: 237.1254,
    y2: 413.69,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109729755828615713700000006145583769300209031_)"
    },
    d: "M252.3-145.8c0,3.5-0.3,13.7-3.4,26.9 c0,0.1,0,0.1,0,0.1c-1.2,5.2-2.9,10.8-5.1,16.7c-9.2,24.2-23.5,49-19.7,64c-0.7-0.3-1.4-0.7-2.1-1.1c0,0-1.7-29.7,14.9-57.2 c10.2-17,13.7-32.4,14.8-41.6C252.2-141.6,252.3-144.3,252.3-145.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102507134827848578310000016885340936605598125_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.15,
    y1: 302.7661,
    x2: 219.15,
    y2: 303.7043,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92314B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000102507134827848578310000016885340936605598125_)"
    },
    d: "M219.9-34.9 c-0.5-0.2-1-0.5-1.5-0.9C219.2-35.3,219.7-35,219.9-34.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174566013016458030910000003203446907308548538_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.8,
    y1: 308.29,
    x2: 135.8,
    y2: 372.59,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174566013016458030910000003203446907308548538_)"
    },
    d: "M164.3-62.4c-1.1-6.7,0-42.3,0-42.3 l-28.5,1.9l-28.5-1.9c0,0,1.1,35.6,0,42.3c0,0-16.1,17.1-43.5,22h72h72C180.3-45.2,164.3-62.4,164.3-62.4z"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M107.7-84.5c0,0,24.9,21.4,56.1,12.5l0.4-32.6c0,0-16.5,11.7-56.9,1.6L107.7-84.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108292279286175871380000005575956631210634885_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.45,
    y1: 308.29,
    x2: 135.45,
    y2: 331.9063,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC5E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108292279286175871380000005575956631210634885_)"
    },
    d: "M211.7-40.4H59.2 c0,0,26.5-8.3,31.3-12.6c1.2-1,2.2-2.2,3.2-3.4c1.7-2,3.2-4.1,4.2-5.5L98-62c0.8-1.2,1.3-1.9,1.4-2c0.4-0.2,7.5,1.5,7.9,1.6l0,0 l-3.5,3.3c0,0,8.2,12.3,32.1,12.3c15.9,0,24.5-5.8,28.4-9.6l0,0c2-1.9,2.8-3.3,2.8-3.3l-2.8-2.6l8-1.7c0,0,0.3,1.9,1.4,4.2 c0.6,1.4,1.4,2.9,2.4,4.3c0.9,1.2,2,2.3,3.3,3.3C184.9-48.3,211.7-40.4,211.7-40.4z"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M172.3-64l-8,7.6l0,0c2-1.9,2.8-3.3,2.8-3.3l-2.8-2.6L172.3-64z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M107.3-62.4l-3.5,3.3L99.4-64C99.7-64.2,106.9-62.5,107.3-62.4L107.3-62.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057147171462697397340000006127020938137929388_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.7475,
    y1: 319.09,
    x2: 125.814,
    y2: 319.09,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000057147171462697397340000006127020938137929388_)",
      enableBackground: "new"
    },
    d: " M98-62c0,0-0.8,7.1,9.3,14.9c7.7,6,18.5,6.7,18.5,6.7s-19.2-0.4-32.1-16L98-62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026147578195022649940000000788061540029569463_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.6677,
    y1: 319.24,
    x2: 176.0677,
    y2: 319.24,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000026147578195022649940000000788061540029569463_)",
      enableBackground: "new"
    },
    d: " M173.6-59.8c0,0-5.8,12-18,16.9c0,0,15.5-3.1,20.4-12.6L173.6-59.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107556894169320455030000013576205082045330365_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.2649,
    y1: 414.3369,
    x2: 216.2649,
    y2: 470.3777,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107556894169320455030000013576205082045330365_)"
    },
    d: "M229.1-176.7c-0.4,1.8-0.8,3.5-1.3,5 c0,0,0,0,0,0.1c-3.3,10.5-8.2,13-10.2,17.7c-1.7,4.1-8.5,12.3-15.2,3.8l0,0c0,0,3.2-34.8,5.7-41.2c0,0,3.7-9.5,10.4-10.9 C227.1-204.2,232.5-192.9,229.1-176.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122700046765139927960000007020667703957030280_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.3786,
    y1: 423.9386,
    x2: 216.3786,
    y2: 460.5125,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000122700046765139927960000007020667703957030280_)",
      enableBackground: "new"
    },
    d: " M204.8-171.8c0,0,13.4-19.4,19.8-20.7c6.4-1.3,3.2,15.2,1.9,20.7s-3.2,8.7-3.2,8.7s1.6-6.5,1.9-11.7c0.5-7.5-1.9-14-4.6-13.4 c-2.7,0.6-6.3,10.1-6.5,11.2c-0.2,1.1,1.8,3,1.7,8.9s-2.9,12.2-4.4,12.1c-1.5-0.1-0.9-4.8-0.9-10.3s-4.3-4.4-6.2-0.9 L204.8-171.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027578493549602142540000015077170319176454556_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.7248,
    y1: 428.1393,
    x2: 209.7248,
    y2: 446.066,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000027578493549602142540000015077170319176454556_)",
      enableBackground: "new"
    },
    d: " M204.2-167.2c0,0,3.4-5.2,5.5-2.8s0.6,8.9,2.2,9.7c1.6,0.8,3.7-4.5,3.3-9.4c-0.4-4.8-2.3-9.2-5.1-8.4l-5.3,6.2L204.2-167.2z"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M227.9-171.7c-3.3,10.5-8.2,13-10.2,17.7c-1.7,4.1-8.5,12.3-15.2,3.8c0.4,0.3,4.3,3.5,8.2,2.1 c4.1-1.5,5.5-5.4,7.2-8.4C219.6-159.5,224.1-161.6,227.9-171.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048476358136517332000000003554951590162981043_",
    gradientUnits: "userSpaceOnUse",
    x1: -830.2625,
    y1: 414.3369,
    x2: -830.2625,
    y2: 470.3777,
    gradientTransform: "matrix(-1 0 0 -1 -777.603 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048476358136517332000000003554951590162981043_)"
    },
    d: "M39.8-176.7c0.4,1.8,0.8,3.5,1.3,5 c0,0,0,0,0,0.1c3.3,10.5,8.2,13,10.2,17.7c1.7,4.1,8.5,12.3,15.2,3.8l0,0c0,0-3.2-34.8-5.7-41.2c0,0-3.7-9.5-10.4-10.9 C41.9-204.2,36.5-192.9,39.8-176.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137844393451743927530000001368682387354408601_",
    gradientUnits: "userSpaceOnUse",
    x1: -830.2244,
    y1: 423.9386,
    x2: -830.2244,
    y2: 460.5125,
    gradientTransform: "matrix(-1 0 0 -1 -777.603 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000137844393451743927530000001368682387354408601_)",
      enableBackground: "new"
    },
    d: " M64.2-171.8c0,0-13.4-19.4-19.8-20.7s-3.2,15.2-1.9,20.7s3.2,8.7,3.2,8.7s-1.6-6.5-1.9-11.7c-0.5-7.5,1.9-14,4.6-13.4 c2.7,0.6,6.3,10.1,6.5,11.2c0.2,1.1-1.8,3-1.7,8.9s2.9,12.2,4.4,12.1c1.5-0.1,0.9-4.8,0.9-10.3s4.3-4.4,6.2-0.9L64.2-171.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142895622777415102210000010798151034003214527_",
    gradientUnits: "userSpaceOnUse",
    x1: -836.7781,
    y1: 428.1393,
    x2: -836.7781,
    y2: 446.066,
    gradientTransform: "matrix(-1 0 0 -1 -777.603 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000142895622777415102210000010798151034003214527_)",
      enableBackground: "new"
    },
    d: " M64.7-167.2c0,0-3.4-5.2-5.5-2.8s-0.6,8.9-2.2,9.7c-1.6,0.8-3.7-4.5-3.3-9.4c0.4-4.8,2.3-9.2,5.1-8.4l5.3,6.2L64.7-167.2z"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M41.1-171.7c3.3,10.5,8.2,13,10.2,17.7c1.7,4.1,8.5,12.3,15.2,3.8c-0.4,0.3-4.3,3.5-8.2,2.1 c-4.1-1.5-5.5-5.4-7.2-8.4C49.3-159.5,44.8-161.6,41.1-171.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004516801993113443350000008087568694429467305_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.5075,
    y1: 364.99,
    x2: 134.5075,
    y2: 550.39,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAA96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4274,
    style: {
      stopColor: "#F9AB99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    style: {
      stopColor: "#FBA38F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FE9983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF967F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004516801993113443350000008087568694429467305_)"
    },
    d: "M205.5-162.6c0,0.2-0.1,0.5-0.2,0.9 c-1.7,9.4-3.5,17.2-5,22c-5.8,18.5-35.6,42.6-65.8,42.6c-30.3,0-60-24.1-65.8-42.6c-0.7-2.2-1.4-5-2.2-8.4 c-2.7-11.7-5.8-29.6-7.6-47.1l0,0c-2-19.9-2.5-39.3,1.1-48.5c2.5-6.5,8.8-14.1,17.9-20.8l0,0c13.5-9.9,33.3-18,56.6-18 c39,0,68.3,22.7,74.5,38.8C214.6-229.2,210.4-189.8,205.5-162.6z"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M205.3-161.7c-1.7,9.4-3.5,17.2-5,22c-5.8,18.5-35.6,42.6-65.8,42.6c-30.3,0-60-24.1-65.8-42.6 c-0.7-2.2-1.4-5-2.2-8.4l0.1-2.1c0,0,1.1,10.9,10.4,23.2c9.2,12.3,33.8,27,57.6,27s49.5-17.9,58.1-28.2 C200.1-137.3,204.3-156.9,205.3-161.7z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121271396967683369860000018262819083216169368_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.15,
    y1: 302.7661,
    x2: 219.15,
    y2: 303.7043,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000121271396967683369860000018262819083216169368_)"
    },
    d: "M219.9-34.9 c-0.5-0.2-1-0.5-1.5-0.9C219.2-35.3,219.7-35,219.9-34.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136392946787661609920000005048262503713054388_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.15,
    y1: 307.0258,
    x2: 220.15,
    y2: 309.4258,
    gradientTransform: "matrix(1 0 0 -1 0 267.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000136392946787661609920000005048262503713054388_)"
    },
    d: "M222-39.1 c-1.2-0.7-2.4-1.5-3.7-2.4L222-39.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165209672952174819890000009054994272337073053_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.05,
    y1: 840.6661,
    x2: 209.05,
    y2: 839.7279,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92314B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165209672952174819890000009054994272337073053_)"
    },
    d: "M209.8,266.7c-0.5-0.2-1-0.5-1.5-0.9 C209.1,266.3,209.6,266.6,209.8,266.7z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054963130625466622940000009067205856321706411_",
    gradientUnits: "userSpaceOnUse",
    x1: 122,
    y1: 837.8,
    x2: 122,
    y2: 773.5,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054963130625466622940000009067205856321706411_)"
    },
    d: "M150.5,241.8c-1.1-6.7,0-42.3,0-42.3 l-28.5,1.9l-28.5-1.9c0,0,1.1,35.6,0,42.3c0,0-16.1,17.1-43.5,22h72h72C166.5,259,150.5,241.8,150.5,241.8z"
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M93.9,219.7c0,0,24.9,21.4,56.1,12.5l0.4-32.6c0,0-16.5,11.7-56.9,1.6L93.9,219.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014634606946367596450000007173048490196690353_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.7,
    y1: 837.7738,
    x2: 121.7,
    y2: 814.1575,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC5E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014634606946367596450000007173048490196690353_)"
    },
    d: "M197.9,263.8H45.5 c0,0,26.5-8.3,31.3-12.6c1.2-1,2.2-2.2,3.2-3.4c1.7-2,3.2-4.1,4.2-5.5l0.1-0.1c0.8-1.2,1.3-1.9,1.4-2c0.4-0.2,7.5,1.5,7.9,1.6 l0,0l-3.5,3.3c0,0,8.2,12.3,32.1,12.3c15.9,0,24.5-5.8,28.4-9.6l0,0c2-1.9,2.8-3.3,2.8-3.3l-2.8-2.6l8-1.7c0,0,0.3,1.9,1.4,4.2 c0.6,1.4,1.4,2.9,2.4,4.3c0.9,1.2,2,2.3,3.3,3.3C171.2,255.9,197.9,263.8,197.9,263.8z"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M158.5,240.2l-8,7.6l0,0c2-1.9,2.8-3.3,2.8-3.3l-2.8-2.6L158.5,240.2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M93.5,241.8l-3.5,3.3l-4.4-4.9C86,240,93.1,241.7,93.5,241.8L93.5,241.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081606601188507833290000010497755875069574578_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.9684,
    y1: 826.9,
    x2: 112.0349,
    y2: 826.9,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000081606601188507833290000010497755875069574578_)",
      enableBackground: "new"
    },
    d: " M84.2,242.1c0,0-0.8,7.1,9.3,14.9c7.7,6,18.5,6.7,18.5,6.7s-19.2-0.4-32.1-16L84.2,242.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179619387521476893290000007329664374629220993_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.9,
    y1: 826.85,
    x2: 162.3,
    y2: 826.85,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000179619387521476893290000007329664374629220993_)",
      enableBackground: "new"
    },
    d: " M159.9,244.4c0,0-5.8,12-18,16.9c0,0,15.5-3.1,20.4-12.6L159.9,244.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150071026848190979510000000054219115703442571_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.5405,
    y1: 731.7115,
    x2: 202.5405,
    y2: 675.6216,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150071026848190979510000000054219115703442571_)"
    },
    d: "M215.4,127.4c-0.4,1.8-0.8,3.5-1.3,5 c0,0,0,0,0,0.1c-3.3,10.5-8.2,13-10.2,17.7c-1.7,4.1-8.5,12.3-15.2,3.8l0,0c0,0,3.2-34.8,5.7-41.2c0,0,3.7-9.5,10.4-10.9 C213.3,100,218.7,111.2,215.4,127.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068667651276998086260000014595503108748549505_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.5786,
    y1: 722.1012,
    x2: 202.5786,
    y2: 685.5273,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000068667651276998086260000014595503108748549505_)",
      enableBackground: "new"
    },
    d: " M191,132.3c0,0,13.4-19.4,19.8-20.7c6.4-1.3,3.2,15.2,1.9,20.7s-3.2,8.7-3.2,8.7s1.6-6.5,1.9-11.7c0.5-7.5-1.9-14-4.6-13.4 c-2.7,0.6-6.3,10.1-6.5,11.2s1.8,3,1.7,8.9s-2.9,12.2-4.4,12.1c-1.5-0.1-0.9-4.8-0.9-10.3s-4.3-4.4-6.2-0.9L191,132.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066501365950014704320000017034706824922199184_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.9248,
    y1: 717.9165,
    x2: 195.9248,
    y2: 699.9898,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000066501365950014704320000017034706824922199184_)",
      enableBackground: "new"
    },
    d: " M190.4,137c0,0,3.4-5.2,5.5-2.8s0.6,8.9,2.2,9.7c1.6,0.8,3.7-4.5,3.3-9.4s-2.3-9.2-5.1-8.4l-5.3,6.2L190.4,137z"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M214.1,132.5c-3.3,10.5-8.2,13-10.2,17.7c-1.7,4.1-8.5,12.3-15.2,3.8c0.4,0.3,4.3,3.5,8.2,2.1 c4.1-1.5,5.5-5.4,7.2-8.4C205.9,144.6,210.4,142.6,214.1,132.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089550668990424739870000000266004892957369508_",
    gradientUnits: "userSpaceOnUse",
    x1: -537.6799,
    y1: 731.7115,
    x2: -537.6799,
    y2: 675.6216,
    gradientTransform: "matrix(-1 0 0 1 -498.8204 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089550668990424739870000000266004892957369508_)"
    },
    d: "M26,127.4c0.4,1.8,0.8,3.5,1.3,5 c0,0,0,0,0,0.1c3.3,10.5,8.2,13,10.2,17.7c1.7,4.1,8.5,12.3,15.2,3.8l0,0c0,0-3.2-34.8-5.7-41.2c0,0-3.7-9.5-10.4-10.9 C28.1,100,22.7,111.2,26,127.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134227575121101691930000001433276648840191653_",
    gradientUnits: "userSpaceOnUse",
    x1: -537.6418,
    y1: 722.1012,
    x2: -537.6418,
    y2: 685.5273,
    gradientTransform: "matrix(-1 0 0 1 -498.8204 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000134227575121101691930000001433276648840191653_)",
      enableBackground: "new"
    },
    d: " M50.4,132.3c0,0-13.4-19.4-19.8-20.7c-6.4-1.3-3.2,15.2-1.9,20.7c1.3,5.5,3.2,8.7,3.2,8.7s-1.6-6.5-1.9-11.7 c-0.5-7.5,1.9-14,4.6-13.4s6.3,10.1,6.5,11.2s-1.8,3-1.7,8.9s2.9,12.2,4.4,12.1c1.5-0.1,0.9-4.8,0.9-10.3s4.3-4.4,6.2-0.9 L50.4,132.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060005654974316465210000015544308023577828774_",
    gradientUnits: "userSpaceOnUse",
    x1: -544.2956,
    y1: 717.9165,
    x2: -544.2956,
    y2: 699.9898,
    gradientTransform: "matrix(-1 0 0 1 -498.8204 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000060005654974316465210000015544308023577828774_)",
      enableBackground: "new"
    },
    d: " M51,137c0,0-3.4-5.2-5.5-2.8s-0.6,8.9-2.2,9.7c-1.6,0.8-3.7-4.5-3.3-9.4c0.4-4.8,2.3-9.2,5.1-8.4l5.3,6.2L51,137z"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M27.3,132.5c3.3,10.5,8.2,13,10.2,17.7c1.7,4.1,8.5,12.3,15.2,3.8c-0.4,0.3-4.3,3.5-8.2,2.1 c-4.1-1.5-5.5-5.4-7.2-8.4C35.5,144.6,31,142.6,27.3,132.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146483579372772267040000016995639169976631476_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.7075,
    y1: 781.1,
    x2: 120.7075,
    y2: 595.7,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAA96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4274,
    style: {
      stopColor: "#F9AB99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    style: {
      stopColor: "#FBA38F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FE9983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF967F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146483579372772267040000016995639169976631476_)"
    },
    d: "M191.7,141.6c0,0.2-0.1,0.5-0.2,0.9 c-1.7,9.4-3.5,17.2-5,22c-5.8,18.5-35.6,42.6-65.8,42.6c-30.3,0-60-24.1-65.8-42.6c-0.7-2.2-1.4-5-2.2-8.4 c-2.7-11.7-5.8-29.6-7.6-47.1l0,0c-2-19.9-2.5-39.3,1.1-48.5C48.7,54,55,46.4,64.1,39.7l0,0c13.5-9.9,33.3-18,56.6-18 c39,0,68.3,22.7,74.5,38.8C200.8,74.9,196.6,114.4,191.7,141.6z"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M191.5,142.5c-1.7,9.4-3.5,17.2-5,22c-5.8,18.5-35.6,42.6-65.8,42.6c-30.3,0-60-24.1-65.8-42.6 c-0.7-2.2-1.4-5-2.2-8.4l0.1-2.1c0,0,1.1,10.9,10.4,23.2c9.2,12.3,33.8,27,57.6,27s49.5-17.9,58.1-28.2 C186.3,166.9,190.6,147.2,191.5,142.5z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100344621663734724700000002026410679988542604_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.05,
    y1: 840.6661,
    x2: 209.05,
    y2: 839.7279,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100344621663734724700000002026410679988542604_)"
    },
    d: "M209.8,266.7c-0.5-0.2-1-0.5-1.5-0.9 C209.1,266.3,209.6,266.6,209.8,266.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110447235052689408630000018135644800564559006_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.05,
    y1: 836.4064,
    x2: 210.05,
    y2: 834.0064,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110447235052689408630000018135644800564559006_)"
    },
    d: "M211.9,262.4c-1.2-0.7-2.4-1.5-3.7-2.4 L211.9,262.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020368568189557278640000003840613012461385913_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.95,
    y1: 764.1029,
    x2: 65.95,
    y2: 763.7089,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6A4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B63651"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020368568189557278640000003840613012461385913_)"
    },
    d: "M64.7,189.7c1.1,0.2,2,0.3,2.5,0.4 C66.4,190.1,65.5,190,64.7,189.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155114519600868427910000013928853292101811353_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.6475,
    y1: 773.5,
    x2: 116.6475,
    y2: 592.1055,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6A4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B63651"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155114519600868427910000013928853292101811353_)"
    },
    d: "M182.8,199.5c0,0,12.3-18.4,11.6-46.2 c-0.1-3.3-0.3-6.6-0.8-9.8c-2.9-24.2-13-47.3-11.5-75.9c1.2-22-14.3-31.4-29.7-35.4c0,0,0,0-0.1,0c-14.5-3.7-28.9-2.6-28.9-2.6 s-18.4-2.3-36.5,3.9c-18,6.2-17,20.5-19.8,36.5c-2.9,16-7.9,45.4-23.6,62.7c-14.8,16.2,5.4,52.5,21.1,57 c-5.8-1.1-18.2-5.1-25.6-18.3c-9.9-17.5-3.5-33.7,6.2-45.3s9.7-38.6,9.7-38.6L46,117.2c0,0-11-47.2,0.7-73.1 c2.1-4.6,4.9-8.5,8.6-11.4c24.6-19,48.8-14,66.8-14s49.5-4.1,66.6,16.8c0.4,0.5,0.8,0.9,1.1,1.4c15.6,22.2,6.5,83,6.8,100.8 c0,0.8,0.1,1.6,0.1,2.5C197.8,159.3,206.8,194.2,182.8,199.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069373459326202805670000000176858806660024722_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.6404,
    y1: 734.9,
    x2: 161.6404,
    y2: 602.7,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6A4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B63651"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069373459326202805670000000176858806660024722_)"
    },
    d: "M126.6,28.7c0,0,33.7,2.8,43.6,13.3 c10,10.5,11,48.5,18.4,62s13.1,26.9,13.9,37.2c0.8,10.2-4.6,19.7-4.6,19.7s2.8-17.9-1-31.2c-3.8-13.4-20.9-34.7-23-58.4 c-2.1-23.6-6.1-27.7-18.4-34.8c-7-4-34.8-7.2-34.8-7.2L126.6,28.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061432879541997757880000015358686588179163558_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.95,
    y1: 685.6,
    x2: 89.95,
    y2: 598.497,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6A4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B63651"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061432879541997757880000015358686588179163558_)"
    },
    d: "M123.6,29.6c0,0-2.6-6.3-24.7-4.9 c-22,1.4-21.8,23.2-28.4,42.7s-10.6,34.3-10.6,34.3l-3.6,9.9c0,0,10.1-22.3,18-50.2S108.2,27.2,123.6,29.6z"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M123.6,29.6c0,0-14.9-5.4-27.7-2.3c-12.7,3.1-19.3,27.3-19.3,27.3S86.9,26.4,123.6,29.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029732544478737426230000006517162259028492696_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.1061,
    y1: 691.2,
    x2: 52.1061,
    y2: 614.5,
    gradientTransform: "matrix(1 0 0 1 0 -574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6A4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B63651"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029732544478737426230000006517162259028492696_)"
    },
    d: "M62.9,40.5c0,0-5.7,25.4-8.1,47L46,117.2 c0,0-11-47.2,0.7-73.1C49.1,44.8,55,45.4,62.9,40.5z"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M157.5,31c0,0,15.5,5.2,19.9,11.1c0,0-3-4.6-2.7-6.2c0.3-1.6,1.9-2.5,3.2-4.9s-1.7-5.6-1.7-5.6l-2.8-1.3 c0,0,1.2,1,0.4,3.9c-0.8,2.8-2.9,3.3-5.9,3.7C164.7,32.1,157.5,31,157.5,31z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M70.6,23.7c0,0,0.1,4,2.3,5.9c2.3,1.9,10.1,2.5,10.1,2.5s3.6-3.9,8-5.8c0,0-7.3,1.7-12.1,0.5 c-4.9-1.2-4.7-4.5-4.7-4.5L70.6,23.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123439957251792020060000004273984940691476393_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.4542,
    y1: -63.8247,
    x2: 537.4542,
    y2: -321.8743,
    gradientTransform: "matrix(-1 0 0 1 566.0808 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9259D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123439957251792020060000004273984940691476393_)"
    },
    d: "M-0.8-193.4c0.6-4.4,1.2-9,1.7-13.8 c0-0.1,0-0.1,0-0.1c0.2-2,0.5-4,0.7-6c1.9-17.2,3.6-35.8,5.1-52.3l0-0.1c0-0.1,0-0.2,0-0.4c0.1-0.8,0.1-1.5,0.2-2.3l0.6-6.4 c0,0,0-0.2,0.1-0.6c0-0.2,0-0.4,0.1-0.6c0-0.4,0.1-0.7,0.1-1.1c0,0,0,0,0-0.1c0-0.3,0.1-0.6,0.1-0.9c0-0.3,0.1-0.7,0.1-1.1 c1.8-18.4,3.4-32.1,5-34.5c0.7-1,2-1.8,3.8-2.2h0c1.1-2.3,4.9-7.5,11.8-5.7c8.1,2.1,30.3,17.8,30.3,17.8l-8.6,8.8l-1.7,1.7 c0,0-11.8-3.3-15.4,3.1c-3.6,6.5,2.1,35.2,9.2,71.1c7.1,35.9,9.6,76.6,9.3,110.6C51.7-80.2,37.2-68,32.3-64.8 c4.1-3.3,6.7-12.3,6.8-12.9c-2.1,3-4.4,5.3-6.8,7.1c-1.2,0.9-2.4,1.7-3.7,2.4l0,0c-0.7,0.4-1.4,0.8-2.1,1.1 c-7.2,3.4-13.5,3.2-13.5,3.2s7.8-0.4,7.5-14.7c-0.2-9.7-12.6-37.9-18.8-69.2c0,0,0-0.1,0-0.1c-1.2-6.3-2.2-12.7-2.8-19.1 c-0.3-2.9-0.5-5.7-0.5-8.6c0-0.3,0-0.5,0-0.5C-1.8-181.9-1.6-187.8-0.8-193.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098918366132094008590000012294188615840162473_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.6609,
    y1: -64.8019,
    x2: 539.6609,
    y2: -310.0656,
    gradientTransform: "matrix(-1 0 0 1 566.0808 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098918366132094008590000012294188615840162473_)"
    },
    d: "M39.2-77.7c-0.2,0.6-2.8,9.6-6.8,12.9 c4.9-3.2,19.4-15.4,19.6-43.6c0.3-34-2.2-74.7-9.3-110.6c-7.1-35.9-12.8-64.6-9.2-71.1c3.5-6.4,15.4-3.1,15.4-3.1l1.7-1.7 l-0.2-3.5c0,0-23.8-12.3-31.8-11.7C12.1-309.6,9-288.3,8-279c0,0.4-0.1,0.8-0.1,1.1c0,0.3-0.1,0.6-0.1,0.9c0,0,0,0,0,0.1 c0,0.4-0.1,0.7-0.1,1.1c0,0.2,0,0.4-0.1,0.6c0,0.4-0.1,0.6-0.1,0.6L7-268.4l-0.2,2.7c0-0.1,0-0.2,0-0.4 c0.6-4.5,5.9-40.9,12.2-41.1c6.8-0.2,11.6,2,11.6,2s-5.3-1.3-14.2,25.9c-8.9,27.3-12.2,54.1-7.2,76.1c5,22,18.4,37.6,32.1,72.1 C55-96.5,39.2-77.7,39.2-77.7c0,0,2.2-27.9-17.2-67.8C2.6-185.3,1.6-213.3,1.6-213.3c-0.2,2-0.5,4-0.7,6c0,0,0,0,0,0.1 c0,1.4,0.4,22.6,10.5,46c10.5,24.2,32.8,59.8,20.8,90.7C34.7-72.4,37.1-74.7,39.2-77.7z"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M50.1-298.3c0,0-15.2-9.1-21.5-6.8c-6.3,2.4-18.1,47.7-18.1,47.7s12.4-17.9,22-20.1c0,0-1.2-11.5,4.3-14.6 c5.5-3.1,11.9-1.1,11.9-1.1L50.1-298.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.7-304.2c0,0-14.7-6.4-14,14.1C48.7-290,53.2-298.5,62.7-304.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027605205483997290920000004303405337736169106_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.1713,
    y1: -70.9421,
    x2: 6.1713,
    y2: -199.7721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9281EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027605205483997290920000004303405337736169106_)"
    },
    d: "M0-199.8c0,0-9.5,26.8-12.3,54.7 c-2.8,27.9,31,58.3,34,64.7c3,6.4,0,9.4,0,9.4s5.3-2.3,2.3-11.8c-3-9.5-34.6-37.4-34.1-63.2C-9.7-171.7-1.6-175.5,0-199.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006667582734943185500000018359918926615915913_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.5478,
    y1: -63.8247,
    x2: 208.5478,
    y2: -324.5981
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9259D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006667582734943185500000018359918926615915913_)"
    },
    d: "M238-193.4c-0.6-4.4-1.2-9-1.7-13.8 c0-0.1,0-0.1,0-0.1c-0.2-2-0.5-4-0.7-6c-1.9-17.2-3.6-35.8-5.1-52.3l0-0.1c0-0.1,0-0.2,0-0.4c-0.1-0.8-0.1-1.5-0.2-2.3l-0.6-6.4 c0,0,0-0.2-0.1-0.6c0-0.2,0-0.4-0.1-0.6c0-0.4-0.1-0.7-0.1-1.1c0,0,0,0,0-0.1c0-0.3-0.1-0.6-0.1-0.9c0-0.3-0.1-0.7-0.1-1.1 c-1.8-18.4-3.4-32.1-5-34.5c-0.7-1-2-1.8-3.8-2.2h0c-1.1-2.3-5.8-10.4-12.7-8.5c-8.1,2.1-29.4,20.6-29.4,20.6l8.6,8.8l1.7,1.7 c0,0,11.8-3.3,15.4,3.1c3.6,6.5-2.1,35.2-9.2,71.1c-7.1,35.9-9.6,76.6-9.3,110.6c0.2,28.2,14.7,40.3,19.6,43.6 c-4.1-3.3-6.7-12.3-6.8-12.9c2.1,3,4.4,5.3,6.8,7.1c1.2,0.9,2.4,1.7,3.7,2.4l0,0c0.7,0.4,1.4,0.8,2.1,1.1 c7.2,3.4,13.5,3.2,13.5,3.2s-7.8-0.4-7.4-14.7c0.2-9.7,12.6-37.9,18.8-69.2c0,0,0-0.1,0-0.1c1.2-6.3,2.2-12.7,2.8-19.1 c0.3-2.9,0.5-5.7,0.5-8.6c0-0.3,0-0.5,0-0.5C239-181.9,238.7-187.8,238-193.4z M208.9-321.4c5,0.3,7.5,3.4,8.4,5 c-8.5-1-21.5,1-21.5,1S202-321.7,208.9-321.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163042503589250488170000013480999533008582042_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.7546,
    y1: -64.8019,
    x2: 210.7546,
    y2: -310.0656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163042503589250488170000013480999533008582042_)"
    },
    d: "M198-77.7c0.2,0.6,2.8,9.6,6.8,12.9 c-4.9-3.2-19.4-15.4-19.6-43.6c-0.3-34,2.2-74.7,9.3-110.6c7.1-35.9,12.8-64.6,9.2-71.1c-3.5-6.4-15.4-3.1-15.4-3.1l-1.7-1.7 l0.2-3.5c0,0,23.8-12.3,31.8-11.7c6.2,0.4,9.4,21.7,10.4,31c0,0.4,0.1,0.8,0.1,1.1c0,0.3,0.1,0.6,0.1,0.9c0,0,0,0,0,0.1 c0,0.4,0.1,0.7,0.1,1.1c0,0.2,0,0.4,0.1,0.6c0,0.4,0.1,0.6,0.1,0.6l0.6,6.4l0.2,2.7c0-0.1,0-0.2,0-0.4 c-0.6-4.5-5.9-40.9-12.2-41.1c-6.8-0.2-11.6,2-11.6,2s5.3-1.3,14.2,25.9c8.9,27.3,12.2,54.1,7.2,76.1s-18.4,37.6-32.1,72.1 C182.2-96.5,198-77.7,198-77.7c0,0-2.2-27.9,17.2-67.8c19.4-39.8,20.4-67.9,20.4-67.9c0.2,2,0.5,4,0.7,6c0,0,0,0,0,0.1 c0,1.4-0.4,22.6-10.5,46c-10.5,24.2-32.8,59.8-20.8,90.7C202.5-72.4,200.1-74.7,198-77.7z"
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M187-298.3c0,0,15.2-9.1,21.5-6.8c6.3,2.4,18.2,47.7,18.2,47.7s-12.4-17.9-22-20.1c0,0,1.2-11.5-4.3-14.6 c-5.5-3.1-11.9-1.1-11.9-1.1L187-298.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M174.4-304.2c0,0,14.7-6.4,14,14.1C188.5-290,184-298.5,174.4-304.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116201867375785209020000005403723618549529768_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.0637,
    y1: -155.7597,
    x2: 236.0637,
    y2: -301.7311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9281EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116201867375785209020000005403723618549529768_)"
    },
    d: "M226.7-301.7c0,0,7.7,35.9,16.3,66 c8.5,30-6.1,80-6.1,80l0,0c0,0,11.4-42.9,6.3-70.6c-5.1-27.6-16-57.2-16.4-65.6C226.2-300.3,226.7-301.7,226.7-301.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132769711977312277290000014483288741026214544_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.6603,
    y1: -67.0349,
    x2: 223.6603,
    y2: -174.7487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132769711977312277290000014483288741026214544_)"
    },
    d: "M238.8-174.7c0,3.5-0.3,13.7-3.4,26.9 c0,0.1,0,0.1,0,0.1c-1.2,5.2-2.9,10.8-5.1,16.7c-9.2,24.2-23.5,49-19.7,64c-0.7-0.3-1.4-0.7-2.1-1.1c0,0-1.7-29.7,14.9-57.2 c10.2-17,13.7-32.4,14.8-41.6C238.7-170.6,238.8-173.3,238.8-174.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129892800027711015060000001164024166771059599_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.6315,
    y1: -63.8636,
    x2: 205.6315,
    y2: -64.8019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92314B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129892800027711015060000001164024166771059599_)"
    },
    d: "M206.4-63.9c-0.5-0.2-1-0.5-1.5-0.9 C205.7-64.3,206.2-64,206.4-63.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141426271264969158150000001889691614775302026_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.62,
    y1: -66.7607,
    x2: 118.62,
    y2: -131.0343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141426271264969158150000001889691614775302026_)"
    },
    d: "M147.1-88.7c-1.1-6.7,0-42.3,0-42.3 l-28.5,1.9L90.1-131c0,0,1.1,35.6,0,42.3c0,0-16.1,17.1-43.5,22h72h72C163.2-71.6,147.1-88.7,147.1-88.7z"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M90.6-110.9c0,0,24.9,21.4,56.1,12.5l0.4-32.6c0,0-16.5,11.7-56.9,1.6L90.6-110.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089570309175571856670000010800195183032509834_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.2848,
    y1: -66.756,
    x2: 118.2848,
    y2: -90.3764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC5E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089570309175571856670000010800195183032509834_)"
    },
    d: "M194.5-66.8H42.1 c0,0,26.5-8.3,31.3-12.6c1.2-1,2.2-2.2,3.2-3.4c1.7-2,3.2-4.1,4.2-5.5l0.1-0.1c0.8-1.2,1.3-1.9,1.4-2c0.4-0.2,7.5,1.5,7.9,1.6 l0,0l-3.5,3.3c0,0,8.2,12.3,32.1,12.3c15.9,0,24.5-5.8,28.4-9.6v0c2-1.9,2.8-3.3,2.8-3.3l-2.8-2.6l8-1.7c0,0,0.3,1.9,1.4,4.2 c0.6,1.4,1.4,2.9,2.4,4.3c0.9,1.2,2,2.3,3.3,3.3C167.8-74.6,194.5-66.8,194.5-66.8z"
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M155.1-90.4l-8,7.6v0c2-1.9,2.8-3.3,2.8-3.3l-2.8-2.6L155.1-90.4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M90.1-88.7l-3.5,3.3l-4.4-4.9C82.6-90.5,89.7-88.8,90.1-88.7L90.1-88.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092415901341289274540000015170140021680304518_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.5837,
    y1: -77.5722,
    x2: 108.6501,
    y2: -77.5722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000092415901341289274540000015170140021680304518_)"
    },
    d: "M80.8-88.4 c0,0-0.8,7.1,9.3,14.9c7.7,6,18.5,6.7,18.5,6.7s-19.2-0.4-32.1-16L80.8-88.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016790443022495841760000005204384088246597548_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.5039,
    y1: -77.7059,
    x2: 158.8959,
    y2: -77.7059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000016790443022495841760000005204384088246597548_)"
    },
    d: "M156.5-86.1 c0,0-5.8,12-18,16.9c0,0,15.5-3.1,20.4-12.6L156.5-86.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055705464104718409490000017317997922586057105_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.1233,
    y1: -172.8109,
    x2: 199.1233,
    y2: -228.9008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055705464104718409490000017317997922586057105_)"
    },
    d: "M212-203.1c-0.4,1.8-0.8,3.5-1.3,5 c0,0,0,0,0,0.1c-3.3,10.5-8.2,13-10.2,17.7c-1.7,4.1-8.5,12.3-15.2,3.8c0,0,0,0,0,0s3.2-34.8,5.7-41.2c0,0,3.7-9.5,10.4-10.9 C209.9-230.6,215.3-219.3,212-203.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054988717457592402450000008316497468048870287_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.1373,
    y1: -182.4126,
    x2: 199.1373,
    y2: -218.982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000054988717457592402450000008316497468048870287_)"
    },
    d: "M187.6-198.2 c0,0,13.4-19.4,19.8-20.7c6.4-1.3,3.2,15.2,1.9,20.7c-1.3,5.5-3.2,8.7-3.2,8.7s1.6-6.5,1.9-11.7c0.5-7.5-1.9-14-4.6-13.4 c-2.7,0.6-6.3,10.1-6.5,11.2c-0.2,1.1,1.8,3,1.7,8.9c-0.1,5.9-2.9,12.2-4.4,12.1c-1.5-0.1-0.9-4.8-0.9-10.3 c0-5.5-4.3-4.4-6.2-0.9L187.6-198.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012459739418431796600000002087853144520197545_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.5397,
    y1: -186.6133,
    x2: 192.5397,
    y2: -204.5399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000012459739418431796600000002087853144520197545_)"
    },
    d: "M187-193.6 c0,0,3.4-5.2,5.5-2.8c2.1,2.4,0.6,8.9,2.2,9.7c1.6,0.8,3.7-4.5,3.3-9.4s-2.3-9.2-5.1-8.4l-5.3,6.2L187-193.6z"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M210.7-198.1c-3.3,10.5-8.2,13-10.2,17.7c-1.7,4.1-8.5,12.3-15.2,3.8c0.4,0.3,4.3,3.5,8.2,2.1 c4.1-1.5,5.5-5.4,7.2-8.4C202.5-185.9,207-188,210.7-198.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018215924448838107220000014418455913745087926_",
    gradientUnits: "userSpaceOnUse",
    x1: -463.0965,
    y1: -172.8109,
    x2: -463.0965,
    y2: -228.9008,
    gradientTransform: "matrix(-1 0 0 1 -427.603 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018215924448838107220000014418455913745087926_)"
    },
    d: "M22.6-203.1c0.4,1.8,0.8,3.5,1.3,5 c0,0,0,0,0,0.1c3.3,10.5,8.2,13,10.2,17.7c1.7,4.1,8.5,12.3,15.2,3.8c0,0,0,0,0,0s-3.2-34.8-5.7-41.2c0,0-3.7-9.5-10.4-10.9 C24.7-230.6,19.3-219.3,22.6-203.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130611424754853384630000004711144883325180341_",
    gradientUnits: "userSpaceOnUse",
    x1: -463.0823,
    y1: -182.4126,
    x2: -463.0823,
    y2: -218.982,
    gradientTransform: "matrix(-1 0 0 1 -427.603 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000130611424754853384630000004711144883325180341_)"
    },
    d: "M47-198.2 c0,0-13.4-19.4-19.8-20.7c-6.4-1.3-3.2,15.2-1.9,20.7c1.3,5.5,3.2,8.7,3.2,8.7s-1.6-6.5-1.9-11.7c-0.5-7.5,1.9-14,4.6-13.4 c2.7,0.6,6.3,10.1,6.5,11.2c0.2,1.1-1.8,3-1.7,8.9c0.1,5.9,2.9,12.2,4.4,12.1c1.5-0.1,0.9-4.8,0.9-10.3c0-5.5,4.3-4.4,6.2-0.9 L47-198.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114039266168795898430000015111814987713519766_",
    gradientUnits: "userSpaceOnUse",
    x1: -469.68,
    y1: -186.6133,
    x2: -469.68,
    y2: -204.5399,
    gradientTransform: "matrix(-1 0 0 1 -427.603 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000114039266168795898430000015111814987713519766_)"
    },
    d: "M47.6-193.6 c0,0-3.4-5.2-5.5-2.8c-2.1,2.4-0.6,8.9-2.2,9.7c-1.6,0.8-3.7-4.5-3.3-9.4s2.3-9.2,5.1-8.4l5.3,6.2L47.6-193.6z"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M23.9-198.1c3.3,10.5,8.2,13,10.2,17.7c1.7,4.1,8.5,12.3,15.2,3.8c-0.4,0.3-4.3,3.5-8.2,2.1 c-4.1-1.5-5.5-5.4-7.2-8.4C32.1-185.9,27.6-188,23.9-198.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018931311252497955900000009604552033568985758_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.283,
    y1: -123.4584,
    x2: 117.283,
    y2: -308.9082
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAA96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4274,
    style: {
      stopColor: "#F9AB99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    style: {
      stopColor: "#FBA38F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FE9983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF967F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018931311252497955900000009604552033568985758_)"
    },
    d: "M188.3-189c0,0.2-0.1,0.5-0.2,0.9 c-1.7,9.4-3.5,17.2-5,22c-5.8,18.5-35.6,42.6-65.8,42.6c-30.3,0-60-24.1-65.8-42.6c-0.7-2.2-1.4-5-2.2-8.4 c-2.7-11.7-5.8-29.6-7.6-47.1c0,0,0,0,0,0c-2-19.9-2.5-39.3,1.1-48.5c2.5-6.5,8.8-14.1,17.9-20.8v0c13.5-9.9,33.3-18,56.6-18 c39,0,68.3,22.7,74.5,38.8C197.4-255.6,193.2-216.2,188.3-189z"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M188.1-188.1c-1.7,9.4-3.5,17.2-5,22c-5.8,18.5-35.6,42.6-65.8,42.6c-30.3,0-60-24.1-65.8-42.6 c-0.7-2.2-1.4-5-2.2-8.4l0.1-2.1c0,0,1.1,10.9,10.4,23.2c9.2,12.3,33.8,27,57.6,27c23.8,0,49.5-17.9,58.1-28.2 C182.9-163.7,187.2-183.3,188.1-188.1z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104665113048190016170000014782022782914244764_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.6315,
    y1: -63.8636,
    x2: 205.6315,
    y2: -64.8019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104665113048190016170000014782022782914244764_)"
    },
    d: "M206.4-63.9c-0.5-0.2-1-0.5-1.5-0.9 C205.7-64.3,206.2-64,206.4-63.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161599785827555419910000000997891906495374475_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.7012,
    y1: -68.1233,
    x2: 206.7012,
    y2: -70.5254
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161599785827555419910000000997891906495374475_)"
    },
    d: "M208.5-68.1c-1.2-0.7-2.4-1.5-3.7-2.4 L208.5-68.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021081315424577440930000015934540733956832129_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.526,
    y1: -140.4268,
    x2: 62.526,
    y2: -140.8208
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6A4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B63651"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021081315424577440930000015934540733956832129_)"
    },
    d: "M61.3-140.8c1.1,0.2,2,0.3,2.5,0.4 C63-140.4,62.1-140.6,61.3-140.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032630167491538940010000012356351065968789154_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.2016,
    y1: -131.0253,
    x2: 113.2016,
    y2: -312.3498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6A4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B63651"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032630167491538940010000012356351065968789154_)"
    },
    d: "M179.4-131c0,0,12.3-18.4,11.6-46.2 c-0.1-3.3-0.3-6.6-0.8-9.8c-2.9-24.2-13-47.3-11.5-75.9c1.2-22-14.3-31.4-29.7-35.4c0,0,0,0-0.1,0c-14.5-3.7-28.9-2.6-28.9-2.6 s-18.4-2.3-36.5,3.9c-18.1,6.2-17.1,20.5-19.9,36.5c-2.9,16-7.9,45.4-23.6,62.7c-14.8,16.2,5.4,52.5,21.1,57 c-5.8-1.1-18.2-5.1-25.6-18.3c-9.9-17.5-3.5-33.7,6.2-45.3c9.7-11.6,9.7-38.6,9.7-38.6l-8.9,29.8c0,0-11-47.2,0.7-73.1 c2.1-4.6,4.9-8.5,8.6-11.4c24.6-19,48.8-14,66.8-14c18,0,49.5-4.1,66.6,16.8c0.4,0.5,0.8,0.9,1.1,1.4c15.6,22.2,6.5,83,6.8,100.8 c0,0.8,0.1,1.6,0.1,2.5C194.4-171.2,203.4-136.4,179.4-131z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132078598883169877050000002628073441188097446_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.2468,
    y1: -169.6091,
    x2: 158.2468,
    y2: -301.8761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6A4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B63651"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132078598883169877050000002628073441188097446_)"
    },
    d: "M123.2-301.9c0,0,33.7,2.8,43.6,13.3 c10,10.5,11,48.5,18.4,62c7.4,13.5,13.1,26.9,13.9,37.2c0.8,10.2-4.6,19.7-4.6,19.7s2.8-17.9-1-31.2c-3.8-13.4-20.9-34.7-23-58.4 c-2.1-23.6-6.1-27.7-18.4-34.8c-7-4-34.8-7.2-34.8-7.2L123.2-301.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039843756449040298860000018284628503431159736_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.555,
    y1: -218.9821,
    x2: 86.555,
    y2: -306.0547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6A4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B63651"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039843756449040298860000018284628503431159736_)"
    },
    d: "M120.2-300.9c0,0-2.6-6.3-24.7-4.9 c-22,1.4-21.8,23.2-28.4,42.7c-6.6,19.5-10.6,34.3-10.6,34.3l-3.6,9.9c0,0,10.1-22.3,18-50.2S104.9-303.4,120.2-300.9z"
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M120.2-300.9c0,0-14.9-5.4-27.7-2.3c-12.7,3.1-19.3,27.3-19.3,27.3S83.5-304.2,120.2-300.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031909513455239119400000013288232419213698181_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.3464,
    y1: -186.6087,
    x2: 172.3464,
    y2: -298.3383
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031909513455239119400000013288232419213698181_)"
    },
    d: "M193.2-192.7c0,0.8,0.1,1.6,0.1,2.5 l-2.7,3.6l-0.3-0.4c-2.9-24.2-13-47.3-11.5-75.9c1.2-22-14.3-31.4-29.7-35.4c1.8,0.1,21.6,2.1,28.5,14.7c7.2,13.2,8.7-9.8,8.7-9.8 C202-271.3,192.9-210.5,193.2-192.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093141004335016902660000007194115834482877594_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.7107,
    y1: -213.3118,
    x2: 48.7107,
    y2: -290.044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093141004335016902660000007194115834482877594_)"
    },
    d: "M59.6-290c0,0-5.7,25.4-8.1,47l-8.9,29.8 c0,0-11-47.2,0.7-73.1C45.7-285.8,51.6-285.1,59.6-290z"
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M154.1-299.6c0,0,15.5,5.2,19.9,11.1c0,0-3-4.6-2.7-6.2c0.3-1.6,1.9-2.5,3.2-4.9c1.3-2.4-1.7-5.6-1.7-5.6 l-2.8-1.3c0,0,1.2,1,0.4,3.9c-0.8,2.8-2.9,3.3-5.9,3.7C161.4-298.4,154.1-299.6,154.1-299.6z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M67.3-306.8c0,0,0.1,4,2.3,5.9c2.3,1.9,10.1,2.5,10.1,2.5s3.6-3.9,8-5.8c0,0-7.3,1.7-12.1,0.5 c-4.9-1.2-4.7-4.5-4.7-4.5L67.3-306.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair5);
export default __webpack_public_path__ + "static/media/Hair5.59bd3fdf25c71743fd5ddfbd999a0bff.svg";
export { ForwardRef as ReactComponent };